import { partial } from 'lodash';

export const getIssueOptions = (issue, handleMergeShifts) => {
  const scheduledShifts = Array.isArray(issue.get('meta').toJS())
    ? issue.get('meta')
    : issue.getIn(['meta', 'scheduled_shifts']);
  const options = scheduledShifts.map(scheduledShift => ({
    label: scheduledShift.get('label'),
    onClick: partial(handleMergeShifts, scheduledShift.get('id')),
    color: 'navy',
    paddingLeft: 18,
  }));
  return options;
};
